import { render, staticRenderFns } from "./VocabularySelect.vue?vue&type=template&id=13e244d2&scoped=true&"
import script from "./VocabularySelect.vue?vue&type=script&lang=js&"
export * from "./VocabularySelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e244d2",
  null
  
)

export default component.exports